import React, { useState } from 'react'
import './FAQ.css'
import { Accordion } from 'react-bootstrap';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Common_Banner from '../common-components/common_banner/Common_Banner';

const FAQ = () => {

    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "FREQUENTLY ASKED QUESTIONS", link: "", isActive: true },
    ];


    const [activeKey, setActiveKey] = useState("0");

    return (
        <section className='FAQ'>
            <Common_Banner
                imgSrc={"/assets/images/faq/banner.png"}
            />

            <div className='container'>
                {/* <div className='top_div'>
                    <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                </div> */}

                <div className='faq_div'>
                    <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                        {[0, 1, 3, 4].map((key) => (
                            <Accordion.Item eventKey={key.toString()} key={key}>
                                <Accordion.Header>
                                    <p className="question_text">
                                     What are counterfeit detections and what is the difference between them? For example ultraviolet light, metal thread, infrared, etc.
                                    </p>

                                    <div className="icon_holder">
                                        <FontAwesomeIcon
                                            icon={activeKey === key.toString() ? faAngleUp : faAngleDown}
                                            className="icon_text"
                                        />
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='answer_div'>
                                        <p className='faq_answer_text'>
                                       All banknotes incorporate various security features that help you identify a genuine banknote. For example when UV light is shone on certain banknotes, UV markings printed on the banknote illuminate. Different counterfeit detections check different security features. The more counterfeit detections the device has, the higher the detection accuracy.
                                        </p>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>

            </div>



        </section>
    )
}

export default FAQ
